import { Sex } from '../../gql/gql-types';

export const Dictionary = {
  UserSex: {
    [Sex.Male]: '男性',
    [Sex.Female]: '女性',
  },
} as const;
